var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button alpha",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('span',{class:_vm.subLabel ? '' : 'button-text'},[_vm._t("default",function(){return [_vm._v("Continue")]})],2),_c('div',[_vm._v(_vm._s(_vm.subLabel))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }